import { render, staticRenderFns } from "./DataTransferModal.vue?vue&type=template&id=336903ec&scoped=true&"
import script from "./DataTransferModal.vue?vue&type=script&lang=js&"
export * from "./DataTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./DataTransferModal.vue?vue&type=style&index=0&id=336903ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336903ec",
  null
  
)

export default component.exports